<p-drawer
  [visible]="display"
  position="right"
  (onHide)="onHide()"
  appendTo="body">
  <div class="mb-2 left-sidebar">
    <h1 class="mb-3">Select a purchase order to link sales line to</h1>
    <div class="form-group has-float-label mb-4">
      <p-select
        class="p-0"
        [(ngModel)]="purchaseOrderSelected"
        [options]="purchaseOrderIdList"
        optionValue="PurchaseOrderId"
        optionLabel="PurchaseOrderId"
        [showClear]="true"
        [filter]="true"
        [placeholder]="'Select a purchase order'">
      </p-select>
      <label class="form-label"
        >Purchase Order<span class="madatory-field">*</span></label
      >
    </div>
    <button
      class="btn btn-primary me-3 post"
      type="submit"
      [disabled]="!purchaseOrderSelected"
      (click)="onSubmit()">
      save
    </button>
  </div>
</p-drawer>
